import React, { Component } from 'react'
import { Alert } from 'react-bootstrap'
import StatusMessage from "../lib/statusmessage"
import { RegisterLicense } from '../api/licenses'

class RegisterKey extends Component {
    constructor(props) {
        super(props);
        this.state= {
            Registering:false,
            KeyInputValue: '',
            Alert:null
        }
        this.registerSerial = this.registerSerial.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.KeyInputValueKeypress = this.KeyInputValueKeypress.bind(this);
    }

    async registerSerial(){
        if(this.state.KeyInputValue ==''){
            this.setState({
                Alert: new StatusMessage({
                    Status: "danger",
                    Message: "Please enter a key.",
                })
            })
        }else{
            try {
                this.setState({
                    Registering: true
                })
                let register = await RegisterLicense({ key: this.state.KeyInputValue});
    
    
                this.setState({
                    Alert: new StatusMessage({
                        Status: register.success ? "success" : "danger",
                        Message: register.message,
                    })
                })
    
            } catch (ex) {
                this.setState({
                    Alert: new StatusMessage({
                        Status: 'danger',
                        Message: `${ex}`,
                    })
    
                })
            } finally {
                this.setState({
                    Registering: false
                })
            }
        }

    }

    KeyInputValueKeypress(e){
        if(e.key === "Enter"){
            this.registerSerial();
        }
    }

    async handleInputChange(e){
        await this.setState({KeyInputValue: e.target.value});
    }

    render(){
        return (
            <div className="registerakey" id="register">
                <h4>Register A Serial Key</h4>
                <p>When you register your serial key, you can manage your licenses online. You'll also need to register your serial
                key if you plan to create an app for UWP, ASP.NET MVC, or Xamarin.</p>
                {this.state.Alert &&
                        <Alert variant={this.state.Alert.Status}>
                            {this.state.Alert.Message}
                        </Alert>
                    }
                <input className="form-control" name="serial" type="text" id="serial" placeholder="Enter A Serial Key" value={this.state.KeyInputValue} onChange={this.handleInputChange} onKeyPress={this.KeyInputValueKeypress} />
                <button type="button" onClick={(e)=>this.registerSerial()} className="gc-btn primary-action">Register Now{this.state.Registering && <i className="fa fa-spinner fa-spin"></i>}</button>
            </div>
        )
    }
}



export default RegisterKey